import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {InboxesOfflineIndicator} from '../inboxesOfflineIndicator';

/*
 * Props.
 */

interface CellsOfflineIndicatorProps {
  className?: string;
  isOffline: boolean;
}

/*
 * Component.
 */

export const CellsOfflineIndicator: FC<CellsOfflineIndicatorProps> = (props) => (
  <InboxesOfflineIndicator
    className={props.className}
    isOffline={props.isOffline}
    renderTooltip={() => (
      <Trans id="cells-offline-indicator">
        You will see the latest messages when you&apos;re back online
      </Trans>
    )}
  />
);
